import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .DolphinTradeHubPage {
    width: 100%;
    display: flex;
    justify-content: center;

    iframe {
      display: block;
      width: 100%;
      height: 100vh;
      border: none;
      background: #fff;
    }

    @include respond-to(sm) {
      padding: 0 16px;
    }

    &__iosNotice {
      width: 100%;
      background: #fff;
      // 填满标题以下剩余视口（移动端顶栏65+标题/边距约105），内容垂直居中，底部不留大段灰色
      min-height: calc(100vh - 170px);
      padding: 40px 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      h2 {
        width: 291px;
        font-family: 'Nacelle', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        font-size: 28px;
        font-weight: 700;
        color: #000;
        line-height: 1.3;
        letter-spacing: -0.02em;
        margin: 0 0 15px;
      }

      p {
        width: 291px;
        font-family: 'Nacelle', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        font-size: 15px;
        font-weight: 400;
        color: #080621;
        opacity: 0.6;
        line-height: 24px;
        letter-spacing: 0;
        margin: 0 0 4px;
      }

      p.DolphinTradeHubPage__iosNoticeLine2 {
        line-height: 20px;
        margin-bottom: 40px;
      }
    }

    &__iosNoticeIcon {
      width: 155px;
      height: 172px;
      margin-bottom: 20px;

      img {
        width: 155px;
        height: 172px;
        object-fit: contain;
      }
    }

    &__hourglass {
      width: 49px;
      height: 56px;
      margin: 20px 0;

      img {
        width: 49px;
        height: 56px;
        object-fit: contain;
      }
    }

    &__iosNoticeButton {
      display: inline-block;
      background: #6c5ce7;
      color: #fff;
      padding: 14px 40px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      text-align: center;
      transition: opacity 0.15s;

      &:active {
        opacity: 0.85;
      }
    }
  }

  // 收紧 PageLayout 顶部间距（由 JS 在挂载时给 .PageLayout 加 class）
  .PageLayout.DolphinTradeHubPage--compact {
    margin-top: 10px;

    .PageLayout__header {
      margin-bottom: 10px;
    }
  }
`;

export { staticStyles };
